import { Steps } from "antd";
import React, { FC } from "react";
import "./uiStepper.scss";

const { Step } = Steps;

const steps = [
	{
		title: "First",
	},
	{
		title: "Second",
	},
];

interface StepperProps {
    current: number;
}

const UIStepper: FC<StepperProps> = ({
    current
}) => {
	return (
		<Steps current={current} className="stepper__container">
			{steps.map((_, index) => (
				<Step key={index} icon={<span className="step__content">{index + 1}</span>}/>
			))}
		</Steps>
	);
};

export default UIStepper;
